<div class="history-chart">
    <canvas ref="canvas"></canvas>
</div>

<style scoped>
canvas {
  width: 100%;
  max-width: 590px;
  margin: 0px auto;
  margin-bottom: 50px;
}
</style>

<script>
import { Pie } from "vue-chartjs";
export default {
  name: "HistoryChart",
  extends: Pie,
  props: ["ChartRecords", "ChartCategories"],
  mounted() {
    this.renderChart({
      labels: this.ChartCategories.map(c => c.title),
      datasets: [
        {
          label: "Расходы по категориям",
          data: this.ChartCategories.map(c => {
            return this.ChartRecords.reduce((total, r) => {
              if (r.categoryId === c.id && r.type === "outcome") {
                total += +r.amount;
              }
              return total;
            }, 0);
          }),
          backgroundColor: [
            "rgba(255, 99, 132, 0.2)",
            "rgba(54, 162, 235, 0.2)",
            "rgba(255, 206, 86, 0.2)",
            "rgba(75, 192, 192, 0.2)",
            "rgba(153, 102, 255, 0.2)",
            "rgba(255, 159, 64, 0.2)"
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
            "rgba(75, 192, 192, 1)",
            "rgba(153, 102, 255, 1)",
            "rgba(255, 159, 64, 1)"
          ],
          borderWidth: 1
        }
      ]
    });
  }
};
</script>